"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require(".");
var TYPES = {
    MaintenanceRoute: Symbol("MaintenanceRoute"),
    MaintenanceClient: Symbol("MaintenanceClient"),
    Root: Symbol("Maintenance-Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.MaintenanceRoute).to(_1.MaintenanceRoute);
    bind(TYPES.MaintenanceClient).to(_1.MaintenanceClient);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;
